import { OpeningHours } from './OpeningHours'

export default OpeningHours
